import { render, staticRenderFns } from "./tabs-content.vue?vue&type=template&id=53534e90&scoped=true&"
import script from "./tabs-content.vue?vue&type=script&lang=js&"
export * from "./tabs-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53534e90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/gp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53534e90')) {
      api.createRecord('53534e90', component.options)
    } else {
      api.reload('53534e90', component.options)
    }
    module.hot.accept("./tabs-content.vue?vue&type=template&id=53534e90&scoped=true&", function () {
      api.rerender('53534e90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "webpack/public-site-media-dunk/src/components/base/tabs-content.vue"
export default component.exports